import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const TokenMessage = ({ message, loggedIn }) => {

  return (
    <div className="flex flex-col items-center justify-center h-full bg-slate-800 p-6 rounded-lg shadow-lg shadow-black gap-4">
      <h2 className="text-2xl text-slate-100 font-bold">Pike Authentication</h2>
      <p className="text-slate-200">{message}</p>
      <Link
        to={loggedIn ? '/dashboard' : '/'}
        className="bg-emerald-600 hover:bg-emerald-400 text-white font-semibold px-4 py-2 rounded"
      >
        {loggedIn ? 'Proceed to Dashboard' : 'Back to Login'}
      </Link>
    </div>
  );
};

const Callback = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [tokenMessage, setTokenMessage] = useState('Waiting for token...');

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (code) {
      exchangeCodeForToken(code);
    }
  }, []);

  const exchangeCodeForToken = (code) => {
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
    const redirectUri = process.env.REACT_APP_CALLBACK_URL;
    const tokenUrl = 'https://pike13.com/oauth/token';

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `grant_type=authorization_code&code=${code}&redirect_uri=${redirectUri}&client_id=${clientId}&client_secret=${clientSecret}`
    };

    fetch(tokenUrl, requestOptions)
      .then(response => response.json())
      .then(data => {
        const accessToken = data.access_token;
        localStorage.setItem('accessToken', accessToken);
        if (accessToken) {
          setTokenMessage('Successfully logged into Pike13!');
          setLoggedIn(true);
        } else {
          setTokenMessage('We were unable to connect to your Pike13 account.');
        }
      })
      .catch(error => {
        console.log(error);
        setTokenMessage('Something went very wrong.');
      });
  };

  return (
    <TokenMessage message={tokenMessage} loggedIn={loggedIn} />
  );
};

export default Callback;
